
import { SidebarProvider } from "@/components/ui/sidebar";
import { AdminSidebar } from "@/components/AdminSidebar";
import { PlansGrid } from "@/components/plans/PlansGrid";

const Plans = () => {
  return (
    <SidebarProvider>
      <div className="flex min-h-screen w-full bg-gray-100">
        <AdminSidebar />
        <div className="flex-1">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
            <div className="mb-12">
              <h1 className="text-4xl font-bold" style={{ color: "#008169" }}>
                Plans
              </h1>
              <p className="text-xl text-gray-600 mt-2">
                Configure and manage subscriptions
              </p>
            </div>
            <PlansGrid />
          </div>
        </div>
      </div>
    </SidebarProvider>
  );
};

export default Plans;
